import request from '@/utils/request';
import { baseUrl } from '@/common/settings';
// 用户按钮权限信息
export function getBtnAuthMenu(functionCode) {
  return request({
    url: '/system/user/role/buttons?functionCode=' + functionCode,
    method: 'get'
  });
}
export function getBtnAuthList() {
  return request({
    url: `${baseUrl}/ZFSRM_BC_AUTH_SRV/page_buttonSet`,
    method: 'get'
  });
}
export function getUserInfo() {
  return request({
    url: `/auth/biel/getUserInfo`,
    method: 'get'
  });
}
// 投策-用户按钮权限信息
export function getImBtnAuthMenu(functionCode) {
  return request({
    url: '/system/user/role/im-function-button?functionCode=' + functionCode,
    method: 'get'
  });
}
// 前端加锁
export function lock(data) {
  return request({
    url: '/system/user/userLock',
    method: 'post',
    data
  });
}
// 前端解锁
export function unLock(data) {
  return request({
    url: '/system/user/userUnLock',
    method: 'post',
    data
  });
}
// 前端解锁
export function ckeckLock(data) {
  return request({
    url: '/system/user/userUnLock',
    method: 'post',
    data
  });
}
export function getInfo() {
  return request({
    url: '/system/user/me',
    method: 'get'
  });
}
// 用户菜单权限信息
export function getAuthMenu(uri) {
  return request({
    url: `${baseUrl}/ZFSRM_BC_AUTH_SRV/${uri}`,
    method: 'get'
  });
}
// 用户菜单权限信息
export function getMenuPermission() {
  // 获取权限
  return request({
    url: '/system/user/getUserAuth',
    method: 'get'
  });
}